<template>
  <a-card :bordered="false">
    <a-empty
      v-show="currentRoleId == ''"
      :description="$t('msg.E_K0003005_05')"
      style="margin: calc(10% - 32px) 0px 10%"
    />
    <div v-show="currentRoleId != ''">
      <!-- 検索区域 -->
      <div class="table-page-search-wrapper">
        <!-- 搜索区域 -->
        <a-form-model layout="inline" @keyup.enter.native="searchQuery(false, false)">
          <a-row :gutter="24">
            <a-col :sm="24" :md="10" :lg="8" :xl="10" :xxl="7">
              <a-form-model-item label="">
                <a-input
                  :placeholder="$t('disp.ph.matchOr', [$t('disp.username'), $t('disp.realname')])"
                  v-model="queryParam.username"
                ></a-input>
              </a-form-model-item>
            </a-col>
            <span>
              <a-col :xs="1" :sm="1" class="width-fit-content">
                <a-form-model-item :wrapperCol="{ span: 24 }">
                  <a-button type="primary" @click="searchQuery(false, false)" icon="search">{{
                    $t('disp.btn.search')
                  }}</a-button>
                  <a-button @click="searchReset" icon="stop">{{ $t('disp.btn.reset') }}</a-button>
                </a-form-model-item>
              </a-col>
            </span>
          </a-row>
        </a-form-model>
      </div>
      <!-- ボタン操作区域 -->
      <div class="table-operator" :md="24" :sm="24" style="margin-top: -15px">
        <a-button @click="$refs.SelectUser.visible = true" type="primary" icon="plus">{{
          $t('disp.btn.add')
        }}</a-button>
        <a-button v-if="selectedRowKeys.length > 0" @click="batchDel" icon="close">{{
          this.$t('disp.user.batch.delete.btn')
        }}</a-button>
      </div>

      <!-- table区域-begin -->
      <div>
        <div class="ant-alert ant-alert-info div-selected-info">
          <i class="anticon anticon-info-circle ant-alert-icon"></i>
          {{ this.$t('disp.selected') }}
          <a class="a-selected-info">{{ selectedRowKeys.length }}</a>
          {{ this.$t('disp.item') }}
          <a @click="onClearSelected">{{ this.$t('disp.clear') }}</a>
        </div>

        <a-table
          ref="table"
          tableLayout="auto"
          class="action"
          :dataSource="dataSource"
          :pagination="ipagination"
          :loading="loading"
          @change="handleTableChange"
          :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        >
          <a-table-column key="username" data-index="username" title="员工编号" />

          <a-table-column key="realname" data-index="realname" title="姓名">
            <div slot-scope="text, record" style="font-size: 14px; white-space: nowrap">
              <div style="width: 26px; display: inline-block; margin-right: 10px">
                <a-tag color="blue" style="min-width: unset; transform: scale(0.9)" v-if="record.sex == 1"
                  ><span class="mdi mdi-gender-male"></span
                ></a-tag>
                <a-tag color="pink" style="min-width: unset; transform: scale(0.9)" v-if="record.sex == 2"
                  ><span class="mdi mdi-gender-female"></span
                ></a-tag>
              </div>

              <span>{{ record.realname }}</span>
            </div>
          </a-table-column>

          <a-table-column key="workAddr" data-index="workAddr" title="工作地点" align="left" />

          <a-table-column key="relations" data-index="relations" align="left">
            <span slot="title">
              <span>所属信息</span>
              <!--<br />
              <span class="note">（点击标签可编辑）</span>-->
            </span>
            <template slot-scope="text, record">
              <div v-for="row in record.relations" :key="row.id">
                <div class="relation-wrapper">
                  <a-tag color="pink" v-if="row.departId == currentDeptId && queryParam.includeChildren">{{
                    row.departName
                  }}</a-tag>
                  <a-tag color="blue" v-else>{{ row.departName }}</a-tag>
                  <a-tag color="green" v-if="row.positionName">{{ row.positionName }}</a-tag>
                  <a-tag color="orange" v-if="row.bizLineName">{{ row.bizLineName }}</a-tag>
                </div>
              </div>
            </template>
          </a-table-column>

          <a-table-column key="postLevel" data-index="postLevel" title="职级" :width="60" align="center">
            <template slot-scope="text, record">
              <a-tag color="purple" v-if="record.postLevel">{{ record.postLevel }}</a-tag>
            </template>
          </a-table-column>

          <a-table-column key="delFlag" data-index="delFlag" title="状态" :width="90" align="center">
            <template slot-scope="text, record">
              <!-- 系统用户 -->
              <a-tag color="blue" v-if="record.delFlag == '0' && !record.employeeType && !record.entryDay"
                >系统用户</a-tag
              >
              <!-- 离职 -->
              <a-tag v-else-if="record.delFlag == '1' && record.retirementDay">离职</a-tag>
              <!-- 削除 -->
              <a-tag v-else-if="record.delFlag == '1' && !record.retirementDay">删除</a-tag>
              <!-- 等待入职 -->
              <a-tag color="orange" v-else-if="record.delFlag == '-1'">等待入职</a-tag>
              <!-- 即将离职 -->
              <a-tag
                color="red"
                v-else-if="
                  record.delFlag == '0' &&
                  record.retirementDay &&
                  moment(record.retirementDay).isAfter(moment(new Date()))
                "
                >即将离职</a-tag
              >
              <!-- 试用期 -->
              <a-tag color="cyan" v-else-if="!record.regularFlag">试用期</a-tag>
              <!-- 在职 -->
              <a-tag color="green" v-else>在职</a-tag>
            </template>
          </a-table-column>

          <a-table-column key="action" title="操作" align="center">
            <div slot-scope="text, record" style="white-space: nowrap">
              <a-popconfirm
                placement="topRight"
                :title="$t('msg.confirm.remove')"
                @confirm="() => handleDelete(record.id)"
              >
                <a>{{ $t('disp.btn.remove') }}</a>
              </a-popconfirm>
            </div>
          </a-table-column>
        </a-table>
      </div>
      <!-- table区域-end -->

      <!-- フォーム区域 -->
      <SelectUser
        ref="SelectUser"
        @emit="emitFromSelectUser"
        :params="{
          isMulti: true,
          parent: 'RoleUserInfo',
        }"
      ></SelectUser>
      <!-- <SelectEmployee
        ref="SelectEmployee"
        @emit="emitFromSelectEmployee"
        :params="{
          isMulti: true,
          excludeRoleId: currentRoleId,
          parent: 'RoleUserInfo',
        }"
      ></SelectEmployee> -->
    </div>
  </a-card>
</template>

<script>
import { tableMixin } from '@/mixins/tableMixin'
import { getAction, postAction, deleteAction, putAction } from '@/api/manage'
// import SelectEmployee from '@/views/k01/k0101/SelectEmployee'
import SelectUser from '@/views/k00/k0014/modules/SelectUser'
import { queryPost } from '@/api/api'

export default {
  name: 'RoleUserInfo',
  mixins: [tableMixin],
  components: {
    SelectUser,
  },
  data() {
    return {
      description: this.$t('disp.userInfo'),
      disableMixinSearchQuery: true,
      currentRoleId: '',
      queryParam: {
        username: '',
        includeChildren: false,
        roleId: '',
      },
      url: {
        list: '/blaze-sys/k00/k0014/UserManage/roleUserList',
        add: '/blaze-sys/k00/k0014/UserManage/addUserToRole',
        delete: '/blaze-sys/k00/k0014/UserManage/deleteUserInRole',
        deleteBatch: '/blaze-sys/k00/k0014/UserManage/deleteUserInRoleBatch',
      },
    }
  },
  mounted() {},
  methods: {
    callbackBeforeSearchQuery() {
      this.queryParam.roleId = this.currentRoleId
    },
    batchDel: function () {
      if (!this.url.deleteBatch) {
        this.$message.error(this.$t('disp.setUrlDeleteBatch'))
        return
      }

      if (this.selectedRowKeys.length <= 0) {
        this.$message.warning(this.$t('disp.rules.select'))
        return
      } else {
        var userIds = ''
        for (var a = 0; a < this.selectedRowKeys.length; a++) {
          userIds += this.selectedRowKeys[a] + ','
        }
        var that = this
        this.$confirm({
          title: that.$t('disp.warn'),
          content: that.$t('msg.confirm.removeBatch'),
          onOk: function () {
            deleteAction(that.url.deleteBatch, { roleId: that.currentRoleId, userIds: userIds }).then((res) => {
              if (res.success) {
                that.$message.success(that.$t('msg.remove.success'))
                that.searchQuery(true, false)
                that.onClearSelected()
              }
            })
          },
        })
      }
    },
    handleDelete: function (userId) {
      if (!this.url.delete) {
        this.$message.error(this.$t('disp.setUrlDelete'))
        return
      }
      var that = this
      deleteAction(that.url.delete, { roleId: that.currentRoleId, userId: userId }).then((res) => {
        if (res.success) {
          that.$message.success(that.$t('msg.remove.success'))
          if (that.selectedRowKeys.length > 0) {
            for (let i = 0; i < that.selectedRowKeys.length; i++) {
              if (that.selectedRowKeys[i] == userId) {
                that.selectedRowKeys.splice(i, 1)
                break
              }
            }
          }
          that.searchQuery(true, false)
        }
      })
    },
    open(record) {
      this.currentRoleId = record.id
      this.searchQuery(false, false)
    },
    clearList() {
      this.currentRoleId = ''
      this.dataSource = []
    },
    emitFromSelectUser(data) {
      let params = {}
      params.roleId = this.currentRoleId
      params.userIdList = []
      for (var i = 0; i < data.length; i++) {
        params.userIdList.push(data[i].id)
      }
      postAction(this.url.add, params).then((res) => {
        if (res.success) {
          this.$message.success(this.$t(res.message))
          this.searchQuery(false, false)
        }
      })
    },
  },
}
</script>
<style lang="less" scoped>
.ant-card {
  margin-left: -10px;
}

.table-page-search-wrapper {
  margin-top: -16px;
  margin-bottom: 16px;
}

:global(.ant-select) {
  :global(.ant-select-selection) {
    background-color: transparent;
    border: none;
    cursor: pointer;
    box-shadow: none;

    :global(input.ant-select-search__field) {
      width: 0px;
    }
  }
}
</style>
